export const SORTABLE_COLUMNS = {
    "Shipment Number": "shipmentNumber",
    "Office Code": "officeCode",
    "Status": "status",
    "PO Number": "poNumber",
    "Sales Order": "salesOrderNumber",
    "Booking Number": "bookingNumber",
    "Planned Pickup Date": "pickupDate",
    "Scheduled Pickup Time": "pickupDate",
    "Planned Delivery Date": "deliveryDate",
    "Scheduled Delivery Time": "deliveryDate",
    "Ready for Pickup Date Time": "readyForPickupDateTime",
    "Created Date": "createdDate",
    "Updated Date": "updatedDate",
    "Total Charges": "totalCharge",
    "Carrier Name": "carrierName",
    "Carrier SCAC Code": "carrierOfficeCode.partyOfficeCode",
    "PRO Number": "proNumber",
    "Equipment Number": "equipmentNumber",
    "Mode": "movementType",
    "Payment Type": "paymentMethod",
    "Origin": "portOfOrigin",
    "Destination": "portOfDestination",
    "Destination Country": "destinationCountry",
    "Destination State": "destinationState",
    "Destination City": "destinationCity",
    "Destination Zip": "destinationZipCode",
    "Is Invoiced": "isInvoiced",
    "Invoice Number": "invoiceNumber",
    "Invoice Status": "invoiceStatus",
    "Pickup Location Reason Name": "stopReasonName",
    "Actual Pickup Time": "actualGateIn",
    "Actual Delivery Time": "actualGateOut",
    "Pickup Appointment Time": "pickupAppointmentStartDate",
  };


export const FILTER_TABS = {
    ALL: "ALL",
    DT: "DROP_TRAILER",
    NOT_INVOICED: "NOT_INVOICED",
}